import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuthStore } from "@/store/authStore";
import { useMe } from "./hooks";

interface Props {
  roles?: Array<"STUDENT" | "INSTRUCTOR" | "ADMIN">;
}

export default function RequireAuth({ roles }: Props) {
  const location = useLocation();
  const accessToken = useAuthStore((s) => s.accessToken);
  const authReady = useAuthStore((s) => s.authReady);
  const user = useAuthStore((s) => s.user);
  const meQuery = useMe();

  // AuthInit henüz refresh denemesini bitirmedi → spinner göster, yönlendirme yapma
  if (!authReady) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!accessToken) {
    return <Navigate to="/giris" state={{ from: location.pathname }} replace />;
  }

  // Rol korumalı route'larda user yüklenmeden Outlet açma —
  // eski/stale role ile yanlış yönlendirme veya kısa süreli sızıntı olmasın.
  if (roles && !user) {
    if (meQuery.isError) {
      return <Navigate to="/giris" state={{ from: location.pathname }} replace />;
    }
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (roles && user && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
